import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Products  </h2>
          <p>
          Wide variety of products available.
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items"
          style={{width: "100%", height: "60%",display: "flex", justifyContent: "space-evenly",paddingLeft:'100px',alignItems: "center",flexDirection:'row',flexWrap:'wrap'}}
          >
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    style={{width: "250px",paddingBottom:'20px',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'flex-start'}}
                   >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                      />
                      <h4 style={{textAlign:'center',fontSize:'18px',fontWeight:'bold',color:'#000',paddingBottom:'8px'}}>{d.title}</h4>
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
